import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import BuyWithAddToOrderButton from './BuyWithAddToOrderButton';

import performChangeOrder from '../../../actions/performChangeOrder';
import controlWindowsWithInvalidConfigurationsModal from '../../../actions/uiState/controlWindowsWithInvalidConfigurationsModal';

const mapStateToProps = ({ estimateBuilder: { uiState } }) => ({
  // eslint-disable-next-line max-len
  windowsWithInvalidConfigurations: uiState.windowsWithInvalidConfigurations ? uiState.windowsWithInvalidConfigurations : [],
  // eslint-disable-next-line max-len
  showWindowsWithInvalidConfigurationsModal: uiState.windowsWithInvalidConfigurationsModalOpen ? uiState.windowsWithInvalidConfigurationsModalOpen : false,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      performChangeOrder,
      controlWindowsWithInvalidConfigurationsModal,
    },
    dispatch,
  );
export default connect(mapStateToProps, mapDispatchToProps)(BuyWithAddToOrderButton);
